export const cargoServices = [
  {
    id: 9,
    title: "Jet Kargo",
    images: [
      {
        id: 2,
        original:
          "https://kolaykargo-static.s3.amazonaws.com/media/images/services/2021/11/jet_kargo.jpg",
        caption: "",
        display_order: 0,
        date_created: "2021-10-24T22:15:10.195063Z",
      },
    ],
    rating: 4.8,
    attributes: [
      {
        name: "From City",
        value: ["Ankara", "Istanbul"],
        code: "from_city",
      },
      {
        name: "To City",
        value: ["Mary"],
        code: "to_city",
      },
      {
        name: "Minimum Weight",
        value: 25,
        code: "minimum_weight",
      },
      {
        name: "Maximum Delivery Days",
        value: 12,
        code: "max_delivery_days",
      },
      {
        name: "Minimum Delivery Days",
        value: 8,
        code: "min_delivery_days",
      },
    ],
    records: [
      {
        id: 2,
        url: "https://kolaykargo.herokuapp.com/api/services/9/stockrecords/2/",
        partner_sku: "12345",
        price_currency: "USD",
        price: "1.20",
        num_in_stock: 1000,
        num_allocated: 224,
        low_stock_threshold: 50,
        date_created: "2021-10-24T22:14:53.203833Z",
        date_updated: "2021-10-24T22:14:53.203861Z",
        service: 9,
        partner: 1,
      },
    ],
    reviews: [1, 2, 3, 4, 5, 6, 7, 8],
  },
  {
    id: 8,
    title: "Turkmenexpress",
    images: [
      {
        id: 1,
        original:
          "https://kolaykargo-static.s3.amazonaws.com/media/images/services/2021/11/turkmen_express.jpg",
        caption: "Turkm exp surat",
        display_order: 0,
        date_created: "2021-10-24T22:13:05.123007Z",
      },
    ],
    rating: 5,
    attributes: [
      {
        name: "From City",
        value: ["Ankara", "Istanbul", "Izmir"],
        code: "from_city",
      },
      {
        name: "To City",
        value: ["Ashgabat", "Mary"],
        code: "to_city",
      },
      {
        name: "Minimum Weight",
        value: 10,
        code: "minimum_weight",
      },
      {
        name: "Maximum Delivery Days",
        value: 15,
        code: "max_delivery_days",
      },
      {
        name: "Minimum Delivery Days",
        value: 10,
        code: "min_delivery_days",
      },
    ],
    records: [
      {
        id: 1,
        url: "https://kolaykargo.herokuapp.com/api/services/8/stockrecords/1/",
        partner_sku: "1234",
        price_currency: "USD",
        price: "1.50",
        num_in_stock: 1000,
        num_allocated: null,
        low_stock_threshold: 50,
        date_created: "2021-10-24T22:12:16.604582Z",
        date_updated: "2021-10-24T22:12:16.604608Z",
        service: 8,
        partner: 1,
      },
    ],
    reviews: [9],
  },
  {
    id: 1,
    title: "Fastexpress",
    images: [
      {
        id: 1,
        original:
          "https://kolaykargo-static.s3.amazonaws.com/media/images/services/2021/11/turkmen_express.jpg",
        caption: "Fastexpress",
        display_order: 0,
        date_created: "2021-10-24T22:13:05.123007Z",
      },
    ],
    rating: 5,
    attributes: [
      {
        name: "From City",
        value: ["Ankara", "Istanbul", "Izmir"],
        code: "from_city",
      },
      {
        name: "To City",
        value: ["Ashgabat", "Mary"],
        code: "to_city",
      },
      {
        name: "Minimum Weight",
        value: 20,
        code: "minimum_weight",
      },
      {
        name: "Maximum Delivery Days",
        value: 20,
        code: "max_delivery_days",
      },
      {
        name: "Minimum Delivery Days",
        value: 10,
        code: "min_delivery_days",
      },
    ],
    records: [
      {
        id: 1,
        url: "https://kolaykargo.herokuapp.com/api/services/8/stockrecords/1/",
        partner_sku: "1234",
        price_currency: "USD",
        price: "2.50",
        num_in_stock: 1000,
        num_allocated: null,
        low_stock_threshold: 50,
        date_created: "2021-10-24T22:12:16.604582Z",
        date_updated: "2021-10-24T22:12:16.604608Z",
        service: 1,
        partner: 1,
      },
    ],
    reviews: [9],
  },
  {
    id: 2,
    title: "Loopexpress",
    images: [
      {
        id: 1,
        original:
          "https://kolaykargo-static.s3.amazonaws.com/media/images/services/2021/11/turkmen_express.jpg",
        caption: "Turkm exp surat",
        display_order: 0,
        date_created: "2021-10-24T22:13:05.123007Z",
      },
    ],
    rating: 4.7,
    attributes: [
      {
        name: "From City",
        value: ["Istanbul", "Izmir"],
        code: "from_city",
      },
      {
        name: "To City",
        value: ["Ashgabat", "Mary"],
        code: "to_city",
      },
      {
        name: "Minimum Weight",
        value: 10,
        code: "minimum_weight",
      },
      {
        name: "Maximum Delivery Days",
        value: 15,
        code: "max_delivery_days",
      },
      {
        name: "Minimum Delivery Days",
        value: 10,
        code: "min_delivery_days",
      },
    ],
    records: [
      {
        id: 1,
        url: "https://kolaykargo.herokuapp.com/api/services/8/stockrecords/1/",
        partner_sku: "1234",
        price_currency: "USD",
        price: "1.50",
        num_in_stock: 1000,
        num_allocated: null,
        low_stock_threshold: 50,
        date_created: "2021-10-24T22:12:16.604582Z",
        date_updated: "2021-10-24T22:12:16.604608Z",
        service: 2,
        partner: 1,
      },
    ],
    reviews: [9],
  },
];
